import "./Separator.css";
import Separate from "../separator.png";

const Separator = () => {
  return (
    <div className="separator">
      <img src={Separate} alt="separate"></img>
    </div>
  );
};

export default Separator;
